import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button,
  Input,
  Alert,
  Spinner,
} from "reactstrap";
import { API_WEB_URLS } from "../../constants/constAPI";
import { useDispatch } from "react-redux";
import { Fn_FillListData, Fn_DeleteData } from "../../store/Functions";
import { useNavigate } from "react-router-dom";
import toastr from "toastr";
import "toastr/build/toastr.css";

const PageList_Broker = () => {
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [activeFilter, setActiveFilter] = useState('Active'); // 'All', 'Active', 'InActive'
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const rtPage_Add = "/AddBroker";
  const rtPage_Edit = "/EditBroker";
  const API_URL = API_WEB_URLS.MASTER + "/0/token/BrokerAccount";
  const API_URL_Delete = API_WEB_URLS.MASTER + "/0/token/DeleteBrokerAccount";

  const [state, setState] = useState({
    id: 0,
    FillArray: [],
    formData: {},
    isProgress: true,
  });

  const fetchData = async () => {
    setLoading(true);
    await Fn_FillListData(dispatch, setGridData, "gridData", API_URL + "/Id/0");
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [dispatch, API_URL]);

  const btnAddOnClick = () => {
    navigate(rtPage_Add, { state: { Id: 0 } });
  };

  const btnEditOnClick = (Id) => {
    navigate(rtPage_Edit, { state: { Id } });
  };

  const btnDeleteOnClick = async (Id) => {
    const confirmed = window.confirm("Are you sure you want to delete this broker?");
    if (confirmed) {
      try {
        setLoading(true);
        const response = await Fn_DeleteData(dispatch, setState, Id, `${API_URL_Delete}`, true);
        const msg = response?.data?.message || response?.message || "";
        if (response && response.status === 200 && (msg.toLowerCase().includes("record deleted") || msg.toLowerCase().includes("deleted"))) {
          toastr.success("Broker deleted successfully");
        }
        await fetchData();
      } catch (error) {
        console.error("Error deleting broker:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const filteredData = (gridData || []).filter(item => {
    if (activeFilter === 'Active' && item.IsActive === false) {
      return false;
    }
    if (activeFilter === 'InActive' && item.IsActive !== false) {
      return false;
    }
    
    const searchLower = searchTerm.toLowerCase();
    return (
      (item.Name && item.Name.toLowerCase().includes(searchLower)) ||
      (item.Person && item.Person.toLowerCase().includes(searchLower)) ||
      (item.Address && item.Address.toLowerCase().includes(searchLower)) ||
      (item.City && item.City.toLowerCase().includes(searchLower)) ||
      (item.MobileNo && item.MobileNo.toLowerCase().includes(searchLower)) ||
      (item.PhoneNo && item.PhoneNo.toLowerCase().includes(searchLower)) ||
      (item.GSTNo && item.GSTNo.toLowerCase().includes(searchLower)) ||
      (item.PanNo && item.PanNo.toLowerCase().includes(searchLower))
    );
  });

  const sortedData = [...filteredData].sort((a, b) => {
    if (!sortConfig.key) return 0;
    
    const aVal = a[sortConfig.key] || "";
    const bVal = b[sortConfig.key] || "";
    
    if (aVal < bVal) {
      return sortConfig.direction === 'asc' ? -1 : 1;
    }
    if (aVal > bVal) {
      return sortConfig.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });

  const requestSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xs="12">
            <Card className="shadow-sm border-0">
              <CardHeader className="bg-white border-bottom py-3">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <div>
                    <h5 className="mb-0 fw-bold text-dark d-flex align-items-center">
                      <i className="fas fa-handshake me-2 text-primary"></i>
                      Broker Master (Dalal A/c - Ledger Group 43)
                    </h5>
                    <small className="text-muted">
                      Manage brokers, dalals and commission agents
                    </small>
                  </div>
                  <Button
                    color="primary"
                    size="sm"
                    className="d-flex align-items-center gap-1 shadow-sm"
                    onClick={btnAddOnClick}
                  >
                    <i className="fas fa-plus"></i> Add New Broker
                  </Button>
                </div>
              </CardHeader>

              <CardBody className="p-3">
                {/* Search & Filter Controls */}
                <Row className="mb-3 g-2 align-items-center">
                  <Col md={5} lg={4}>
                    <div className="input-group input-group-sm">
                      <span className="input-group-text bg-light border-end-0">
                        <i className="fas fa-search text-muted"></i>
                      </span>
                      <Input
                        type="text"
                        placeholder="Search by name, person, phone, city..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="border-start-0"
                      />
                      {searchTerm && (
                        <Button
                          color="light"
                          size="sm"
                          onClick={() => setSearchTerm("")}
                        >
                          <i className="fas fa-times"></i>
                        </Button>
                      )}
                    </div>
                  </Col>

                  <Col md={4} lg={3}>
                    <div className="d-flex align-items-center gap-1">
                      <small className="text-muted fw-semibold">Status:</small>
                      <div className="btn-group btn-group-sm" role="group">
                        {['All', 'Active', 'InActive'].map((status) => (
                          <Button
                            key={status}
                            color={activeFilter === status ? "primary" : "outline-secondary"}
                            size="sm"
                            onClick={() => setActiveFilter(status)}
                          >
                            {status}
                          </Button>
                        ))}
                      </div>
                    </div>
                  </Col>

                  <Col md={3} lg={5} className="text-md-end">
                    <span className="badge bg-light text-dark border px-2 py-1">
                      Total: {sortedData.length} broker(s)
                    </span>
                  </Col>
                </Row>

                {/* Table View */}
                {loading ? (
                  <div className="text-center py-5">
                    <Spinner color="primary" />
                    <p className="mt-2 text-muted mb-0">Loading brokers...</p>
                  </div>
                ) : sortedData.length === 0 ? (
                  <Alert color="info" className="text-center my-4 py-4">
                    <i className="fas fa-info-circle fa-2x mb-2 d-block"></i>
                    No brokers found. Click <strong>"Add New Broker"</strong> to create one!
                  </Alert>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-hover table-striped align-middle table-sm border">
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: "50px" }}>#</th>
                          <th
                            onClick={() => requestSort("Name")}
                            style={{ cursor: "pointer" }}
                          >
                            Broker / Firm Name {sortConfig.key === "Name" && (sortConfig.direction === "asc" ? "▲" : "▼")}
                          </th>
                          <th
                            onClick={() => requestSort("Person")}
                            style={{ cursor: "pointer" }}
                          >
                            Contact Person {sortConfig.key === "Person" && (sortConfig.direction === "asc" ? "▲" : "▼")}
                          </th>
                          <th>Station / Address</th>
                          <th>Mobile / Phone</th>
                          <th>GST No</th>
                          <th>PAN No</th>
                          <th style={{ width: "80px" }} className="text-center">Status</th>
                          <th style={{ width: "100px" }} className="text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sortedData.map((item, index) => (
                          <tr key={item.Id || index}>
                            <td>{index + 1}</td>
                            <td className="fw-semibold text-primary">{item.Name}</td>
                            <td>{item.Person || "-"}</td>
                            <td>{item.Address || item.City || "-"}</td>
                            <td>{item.MobileNo || item.PhoneNo || "-"}</td>
                            <td>{item.GSTNo || "-"}</td>
                            <td>{item.PanNo || "-"}</td>
                            <td className="text-center">
                              <span
                                className={`badge ${
                                  item.IsActive === false ? "bg-danger" : "bg-success"
                                }`}
                              >
                                {item.IsActive === false ? "Inactive" : "Active"}
                              </span>
                            </td>
                            <td className="text-center">
                              <div className="btn-group btn-group-sm">
                                <Button
                                  color="info"
                                  size="sm"
                                  className="px-2"
                                  title="Edit Broker"
                                  onClick={() => btnEditOnClick(item.Id)}
                                >
                                  <i className="fas fa-edit"></i>
                                </Button>
                                <Button
                                  color="danger"
                                  size="sm"
                                  className="px-2"
                                  title="Delete Broker"
                                  onClick={() => btnDeleteOnClick(item.Id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default PageList_Broker;
